/**
 * Emoji por cultivo — mismo criterio que los mockups (`PM_Dashboard.html` usa 🍌/☕/🍫/🍋 en
 * "Distribución por cultivo"). Es **solo decorativo**: si un cultivo nuevo no está en el mapa
 * cae en el genérico, nunca rompe. Vive en el frontend a propósito: `tbl_cultivo` no guarda
 * icono y agregar una columna para esto no justifica una migración.
 *
 * El match es por **fragmento del nombre normalizado** (sin acentos, minúsculas), para que
 * "Palma Africana", "Plátano D. Hartón" o "Limón Tahití" caigan en la clave correcta.
 */
const EMOJI_POR_FRAGMENTO: [string, string][] = [
  ["palma", "🌴"],
  ["cacao", "🍫"],
  ["cafe", "☕"],
  ["limon", "🍋"],
  ["cana", "🎋"],
  ["platano", "🍌"],
  ["banano", "🍌"],
  ["mora", "🫐"],
  ["fique", "🌿"],
  ["maiz", "🌽"],
  ["aguacate", "🥑"],
  ["arroz", "🌾"],
  ["caucho", "🌳"],
];

const GENERICO = "🌱";

function normalizar(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

export function cultivoEmoji(cultivoNombre: string | null | undefined): string {
  if (!cultivoNombre) return GENERICO;
  const n = normalizar(cultivoNombre);
  return EMOJI_POR_FRAGMENTO.find(([frag]) => n.includes(frag))?.[1] ?? GENERICO;
}
